var translation = {
	Navatar: {
		header: "Profilo AWS",
		subheader: "Il tuo profilo aiuta a migliorare le interazioni con determinate esperienze AWS.",
		profileButtonText: "Vedi profilo",
		logOutText: "Esci",
		logInText: "Login",
		createProfileText: "Crea profilo",
		federateLoginModalTitle: "Usa Midway per accedere al tuo profilo AWS",
		federateLoginModalFirstDescription: "In qualità di dipendente Amazon, ti consigliamo di utilizzare Midway per accedere al tuo profilo AWS. Questo metodo, consigliato per motivi di sicurezza, garantisce una perfetta integrazione con i sistemi interni.",
		federateLoginModalSecondDescription: "Ricevi questo messaggio perché hai effettuato l'accesso con un indirizzo e-mail Amazon tramite ID Builder AWS. Questo prompt verrà visualizzato ad ogni accesso finché non sceglierai se passare a Midway o continuare con il metodo di accesso attuale.",
		federateLoginModalPrimaryButton: "Accedi con Midway",
		federateLoginModalSecondaryButton: "Continua con ID Builder AWS"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
